// Imported first by each app's entry: Zod otherwise tests whether it may compile code with
// `new Function`, which our content security policy refuses (and reports). Jitless Zod skips
// the test and validates the same way, just without the compiled fast path.
// Zod adopts this object as its global config when it loads (zod/v4/core/core.js), so the
// setting is in place before any schema is built, without pulling Zod into the first download.
const g = globalThis as { __zod_globalConfig?: Record<string, unknown> };
g.__zod_globalConfig = { ...g.__zod_globalConfig, jitless: true };
